import type * as lazyIndex from "./lazyIndex";
import { LazyImport, LazyBootModule, LazyAction } from "owa-bundling-light";

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OneOutlookSuiteHeader" */ "./lazyIndex"), { name: "OneOutlookSuiteHeader" });

// We don't want this to be a lazy component because it needs to be loaded and ready to render
// during boot
export const lazyOneOutlookSuiteHeader: LazyImport<typeof lazyIndex.components, typeof lazyModule> = new LazyImport(lazyModule, m => m.components);

export const lazyToggleMaximize: LazyAction<typeof lazyIndex.toggleMaximize, typeof lazyModule> = new LazyAction(lazyModule, m => m.toggleMaximize);

export const lazyCaptionButtonAction: LazyAction<typeof lazyIndex.captionButtonAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.captionButtonAction);
